export default __webpack_public_path__ + "static/media/Newsletter 016.eb351d34.png";